// components/api.js

// 1. Define a URL base da API
// Exporta a variável diretamente como uma constante nomeada
export const API_BASE_URL = process.env.NODE_ENV === 'development'
  ? 'http://127.0.0.1:8000'
  : ''; 
// O export agora é 'const'